import classNames from 'classnames';
import { FC } from 'react';

import { PropsWithClassname } from '@/app/types';

interface DividerProps extends PropsWithClassname {}

const Divider: FC<DividerProps> = ({ className }) => {
  return <hr className={classNames(className, 'text-neutral-light')} />;
};

export default Divider;
